import * as yup from 'yup';

export const yupPurchaseOrderItemEditModalSchema = yup.object().shape({
  unitCost: yup.number().required(),
  quantity: yup.number().required(),
});
